import React from 'react';
import { useNavigate } from 'react-router-dom'; // Removed useLocation as it's no longer needed
import { useAuth } from '../context/AuthContext';
import SignupForm from '../components/Signup/SignupForm';
import SEO from '../components/SEO/SEO';

const Signup = () => {
  const { signup, isLoading, error, clearError } = useAuth();
  const navigate = useNavigate();

  // OTP verification (Step 2)
  const handleCompleteSignup = async (formData) => {
    clearError();

    try {
      const result = await signup(formData);

      if (result.success) {
        // Redirecting to /explore every time as requested
        navigate('/explore', { replace: true });
      }
    } catch (error) {
      
    }
  };

  return (
    <div className="w-full bg-white">
      <SEO page="signup" />
      <SignupForm
        onCompleteSignup={handleCompleteSignup}
        isLoading={isLoading}
        error={error}
      />
    </div>
  );
};

export default Signup;